"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  UNKNOWN_ERROR: true
};
Object.defineProperty(exports, "UNKNOWN_ERROR", {
  enumerable: true,
  get: function () {
    return _constants.UNKNOWN_ERROR;
  }
});
var _createCustomError = require("./createCustomError");
Object.keys(_createCustomError).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _createCustomError[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _createCustomError[key];
    }
  });
});
var _createCustomErrorWithData = require("./createCustomErrorWithData");
Object.keys(_createCustomErrorWithData).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _createCustomErrorWithData[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _createCustomErrorWithData[key];
    }
  });
});
var _types = require("./types");
Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _types[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _types[key];
    }
  });
});
var _constants = require("./constants");
//# sourceMappingURL=index.js.map